import type { ReactNode } from 'react'

import type { ThemeMode } from '@/hooks/useLightMode'

import { Flex, Stack, Text } from '@hivewatch/dark'

import { settingsColorToken } from '../utils/settingsColorToken'

interface SettingsContentGroupIProps {
  actions?: ReactNode
  children: ReactNode
  colorScheme: ThemeMode
  description?: string
  title: string
}

export const SettingsContentGroup = ({
  actions,
  children,
  colorScheme,
  description,
  title,
}: SettingsContentGroupIProps) => (
  <Stack gap='16px' w='full'>
    <Flex alignItems='center' gap='16px' justifyContent='space-between'>
      <Stack gap='2px'>
        <Text
          as='h3'
          color={settingsColorToken(colorScheme, 'text.primary')}
          textStyle='heading'
        >
          {title}
        </Text>
        {description && (
          <Text
            color={settingsColorToken(colorScheme, 'text.secondary')}
            textStyle='body'
          >
            {description}
          </Text>
        )}
      </Stack>
      {actions}
    </Flex>
    {children}
  </Stack>
)
